import React, { FC, ReactNode } from 'react';

import { BlockedShotIcon, FaceoffIcon, GiveawayIcon, GoalIcon, HitIcon, ShotIcon } from '~/core/customIcons';
import { SvgRink } from '~/core/enums';

import { GameEventTypeCode } from '../../../../enums';
import { CommonGCGame, GameCenterTeam, Play as PlayType } from '../../../../types';

import { EventIcon } from './styles';

const EVENT_ICON_HEIGHT_WIDTH = 150;
const EVENT_ICON_CENTER = 75;

type Props = {
    team: GameCenterTeam;
    game: CommonGCGame;
    play: PlayType;
};

const getIcon = (typeCode: GameEventTypeCode, size: string, coords: string): ReactNode => {
    switch (typeCode) {
        case GameEventTypeCode.GOAL:
            return <GoalIcon width={size} height={size} x={coords} y={coords} />;
        case GameEventTypeCode.FACEOFF:
            return <FaceoffIcon width={size} height={size} x={coords} y={coords} />;
        case GameEventTypeCode.BLOCKED_SHOT:
        case GameEventTypeCode.MISSED_SHOT:
        case GameEventTypeCode.PENALTY:
            return <BlockedShotIcon width={size} height={size} x={coords} y={coords} />;
        case GameEventTypeCode.GIVEAWAY:
        case GameEventTypeCode.TAKEAWAY:
            return <GiveawayIcon width={size} height={size} x={coords} y={coords} />;
        case GameEventTypeCode.HIT:
            return <HitIcon width={size} height={size} x={coords} y={coords} />;
        case GameEventTypeCode.SHOT_ON_GOAL:
            return <ShotIcon width={size} height={size} x={coords} y={coords} />;
        default:
            return null;
    }
};

const EventMarker: FC<Props> = ({ play, game, team }) => {
    // The x y coordinates are based on distance in feet away from center ice, but the rink in our svg is
    // 2400 by 1020 and 0,0 is the top left corner, so we have to translate the coordinates here...
    const locationX: number = (play.details?.xCoord || 0) * 12 + SvgRink.HORIZONTAL_MIDPOINT;
    const locationY: number = (play.details?.yCoord || 0) * -12 + SvgRink.VERTICAL_MIDPOINT;

    return (
        <EventIcon
            xmlns="http://www.w3.org/2000/svg"
            width={EVENT_ICON_HEIGHT_WIDTH}
            height={EVENT_ICON_HEIGHT_WIDTH}
            viewBox="0 0 24 24"
            x={locationX - EVENT_ICON_CENTER}
            y={locationY - EVENT_ICON_CENTER}
            $teamAbbrev={team.abbrev}
            $isHome={team.id === game.homeTeam.id}
        >
            <circle cx={12} cy={12} r="11" />
            {getIcon(play.typeCode, '16', '4')}
        </EventIcon>
    );
};

export default EventMarker;
